import React from "react";
import { Music4 } from "lucide-react";
import { bandData } from "../mock";

const Influences = () => {
  return (
    <section className="py-20 bg-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="w-16 h-16 bg-[#8b5cf6] rounded-full flex items-center justify-center mb-6 mx-auto">
            <Music4 size={32} className="text-white" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Our Influences & Repertoire
          </h2>
          <div className="w-24 h-1 bg-[#8b5cf6] mx-auto mb-6" />
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Drawing inspiration from the legends of fusion, progressive rock, and jazz.
          </p>
        </div>

        {/* Influences Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {bandData.influences.map((artist, index) => (
            <div
              key={index}
              className="bg-[#1a1a2e] rounded-lg p-4 text-center hover:bg-[#ff6b35] hover:text-white transition-all hover:transform hover:scale-105 cursor-default"
            >
              <p className="font-semibold text-white">{artist}</p>
            </div>
          ))}
        </div>

        {/* Original Music Note */}
        <div className="mt-12 bg-[#1a1a2e] rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Plus Original Music!
          </h3>
          <p className="text-white/80 text-lg mb-6">
            We perform our own fusion compositions alongside covers from these legendary artists.
          </p>
          
          {/* YouTube Video */}
          <div className="max-w-4xl mx-auto">
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/PAORD0WUxCk"
                title="Searching Fusion Original Music"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Influences;
